<template>
  <div id="ebNotice" v-if="notice.isShow==true||notice.isShow=='true'">
    <img class="ebNotice-img" :src="$ebConfig.imgPath+'img/eb-notice-bg.png'" alt>
    <div class="ebNotice-box">
      <button type="button" @click="notice.isShow=false" class="el-message-box__headerbtn">
        <i class="el-message-box__close el-icon-close"></i>
      </button>
      <div class="ebNotice-title" v-html="notice.title"></div>
      <div class="ebNotice-text">
        <pre v-html="notice.content"></pre>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { getConstByKey } from '@/services/const-service';
export default {
  name: 'ebNotice',
  data() {
    return {
      timer: null,
      left: Math.floor(Math.random() * (600 - 0 + 1) + 0),
      top: Math.floor(Math.random() * (250 - 0 + 1) + 0),
      maxLeft: 600,
      maxTop: 250,
      leftFlag: true,
      topFlag: true,
      notice: {
        isShow: false
      },
      speed: 1
    };
  },
  mounted() {
    this.getConstByKeyService();
  },
  methods: {
    noticeAnimate: function() {
      this.timer = setInterval(() => {
        $('#ebNotice').css({
          left: this.left,
          top: this.top
        });
        if (this.left > this.maxLeft) {
          this.leftFlag = false;
        } else if (this.left < 0) {
          this.leftFlag = true;
        }
        if (this.leftFlag) {
          this.left += this.speed;
        } else {
          this.left -= this.speed;
        }
        if (this.top > this.maxTop) {
          this.topFlag = false;
        } else if (this.top < 0) {
          this.topFlag = true;
        }
        if (this.topFlag) {
          this.top += this.speed;
        } else {
          this.top -= this.speed;
        }
      }, 16);
    },
    async getConstByKeyService() {
      try {
        let { data } = await getConstByKey('notice');
        if (data.returnCode === '01') {
          if (data.const) {
            this.notice = JSON.parse(data.const.value);
            this.$nextTick(() => {
              if ($('html').hasClass('zoom')) {
                this.speed = 0.85;
              }
              this.noticeAnimate();
              $('#ebNotice .ebNotice-box').mouseenter(() => {
                clearInterval(this.timer);
              });
              $('#ebNotice .ebNotice-box').mouseleave(() => {
                this.noticeAnimate();
              });
            });
          }
        } else {
          this.$message.error('获取通知信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="less" scoped>
#ebNotice {
  position: absolute;
  top: -1000px;
  height: 396px;
  width: 759px;
  // background-image: url('../../assets/img/eb-notice-bg.png');
  // background-repeat: no-repeat;
  // background-size: 759px;
  z-index: 10;
  .ebNotice-img {
    width: 759px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .ebNotice-box {
    position: absolute;
    left: 0;
    top: 0;
    height: 339px;
    width: 619px;
    margin: 28px 0 0 67px;
  }
  .el-message-box__headerbtn {
    right: 30px;
    top: 20px;
    i {
      color: #a18158;
      font-size: 30px;
    }
  }
  .ebNotice-title {
    font-size: 26px;
    text-align: center;
    padding-bottom: 15px;
    padding-top: 24px;
    padding-left: 49px;
  }
  .ebNotice-top {
    text-align: right;
  }
  .ebNotice-text {
    width: 420px;
    padding-left: 52px;
    margin: auto;
    height: 231px;
    line-height: 26px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 9;
  }
  pre {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
  }
}
</style>
